<script>
		import {is_admin, fellow_name} from "../narrate/_Narrate.svelte";

		let { data: fshp, onselect } = $props()

		let memberNames = $derived((fshp.members ?? []).map(fellow_name).join(", "))
</script>


<!------------------------------- HTML ------------------------------------->

<div class="card fshpCard" role="button" tabindex="0" onclick={onselect.bind(fshp)}
     onkeydown={(e) => e.key === 'Enter' && onselect.call(fshp)}>
	<div class="cardTitleRow">
		<h3 class="card-title">{fshp.ID} – {fshp.name}</h3>
		{#if is_admin(fshp)}<span class="tag accent">Admin</span>{/if}
	</div>
	<div class="contentBox">
		{#if fshp.thumbURL}
			<img class="fshpImg" src="/{fshp.thumbURL}" alt={fshp.name}>
		{:else}
			<div class="fshpImg empty">Kein Bild</div>
		{/if}
		<div class="fshpInfo">
			<h4 class="card-kicker">Aufenthaltsort</h4>
			<p><span class="fa icon-location-dot"></span> {fshp.whereabout || "–"}</p>
			<h4 class="card-kicker">Mitglieder</h4>
			<p class="card-meta">{memberNames}</p>
		</div>
	</div>
	{#if fshp.description}
		<p class="descript">{fshp.description}</p>
	{/if}
</div>


<!------------------------------- STYLE ------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	.fshpCard
		width: 420px
		max-width: 100%
		margin: 8px
		cursor: pointer

		&:hover, &:focus-visible
			border-color: colors.$primary-100
			outline: none

	.card-title
		overflow: hidden
		white-space: nowrap
		text-overflow: ellipsis

	.contentBox
		display: grid
		grid-template-columns: 128px minmax(0, 1fr)
		gap: 16px

	.fshpImg
		width: 128px
		height: 128px
		object-fit: cover
		border-radius: 8px
		border: 1px solid colors.$grey-30

		&.empty
			display: grid
			place-items: center
			background: colors.$grey-20
			font-size: 12px
			color: colors.$grey-50

	.fshpInfo
		display: flex
		flex-direction: column
		gap: 4px
		min-width: 0

		p
			padding: 0 0 8px
			font-size: 14px

		.fa
			color: colors.$primary-100
			filter: none

	.descript
		padding: 0
		font-size: 14px
		color: colors.$grey-85
		display: -webkit-box
		-webkit-line-clamp: 2
		-webkit-box-orient: vertical
		overflow: hidden
</style>
